import * as React from 'react';
import { useRef, useEffect, useReducer } from 'react';
import { FormContext } from './FormContext';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { Cell } from './Cell';
import { entries } from '../../../helpers';

export interface SearchProps {
    container: HTMLElement;
    type: string;
    children?: React.ReactNode,
    couldNotResolveLocation?: boolean;
};

interface Props<T> extends SearchProps {
    data: T;
};

interface Action<T, K extends keyof T = keyof T> {
    field: K;
    value: T[K];
};

function reducer <T> (state: T, { field, value }: Action<T>): T {
    return {
        ...state,
        [field]: value,
    };
};

export function Search<T>({ container, type, children, data }: Props<T>) {
    type R = React.Reducer<T, Action<T>>;
    const [state, dispatch] = useReducer<R>(reducer, data);

    const ref = useRef<HTMLFormElement>();
    const [width, height] = useWindowSize();

    useEffect(() => {
        if (ref.current && type === 'normal') {
            const height = ref.current.offsetHeight;

            container.style.marginTop = `${height * -0.5}px`;
        }
    }, [ref, type, container, width, height]);

    return (
        <FormContext.Provider value={{ state, dispatch }}>
            <form method="GET" action="/search" className="search-form" ref={ref}>
                {children}

                <Cell width="100" noSpacing>
                    <input type="submit" className="field submit" value="Search" />
                </Cell>

                {entries(state).map(([key, val]) => (
                    <input
                        key={key}
                        type="hidden"
                        name={key}
                        value={Array.isArray(val) ? val.join(',') : val.toString()}
                    />
                ))}
            </form>
        </FormContext.Provider>
    );
};
